import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UPDATE_BROKERAGE_OVERRIDES } from "./store/settings-actions";
import { SET_LOADING_STATE } from "./store/settings-mutations";
import { mapState, mapActions, mapMutations } from "vuex";
import { delay } from "@Shared/@Utils/utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "OverrideCustomizations",
  props: {
    size: {
      type: String,
      default: "col-lg-12"
    },
    page: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      overrideParsing: {
        faq: "overrideFaq",
        automation: "overrideAutomation",
        applicationForm: "overrideForm",
        coBrokering: "overrideCobrokering"
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("SettingsStore", ["overrides"])), {}, {
    currentOverride() {
      return this.overrideParsing[this.page];
    },
    currentOverrideChecked() {
      if (this.page === "theme") return this.overrides["overrideStyle"] && this.overrides["overrideLogo"];
      return this.overrides[this.currentOverride];
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("SettingsStore", [UPDATE_BROKERAGE_OVERRIDES])), mapMutations("SettingsStore", [SET_LOADING_STATE])), {}, {
    async handleChangeOverride() {
      //this is to have a little delay on the toggle action.
      //i figured it would look better to see the toggle animation before the loading.
      await delay(500);
      this.SET_LOADING_STATE(true);
      const newOverrideObj = this.page === "theme" ? {
        overrideStyle: !this.overrides["overrideStyle"],
        overrideLogo: !this.overrides["overrideLogo"]
      } : {
        [this.currentOverride]: !this.overrides[this.currentOverride]
      };
      await this.UPDATE_BROKERAGE_OVERRIDES(newOverrideObj);
      this.$emit("update-override", newOverrideObj);
      this.SET_LOADING_STATE(false);
    },
    formatPageName(page) {
      if (page === "coBrokering") return "Co-Brokering";
      return page;
    }
  })
});